import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import RubleLightIcon from '../icons/RubleLightIcon';

const FabricFooter = ({
    displayName,
    composition,
    price, 
    density,
    onFabricInfoClicked,
    isMobile
}) => {
	let someS = false;
	if (!displayName.indexOf('Denim')) {
		someS = true;
	}

    return (
        <div className='fabric-builder__footer footer-theme--tgray'>
            <ul className={
                classnames(
                    'fabric-builder__footer-col',
                    'role--main',
                    isMobile && `flex self-center`
                )
            }>
                <li className='fabric-builder__footer-item'>
                    {displayName}
                </li>
                {!isMobile && <li className='fabric-builder__footer-item'>
                    {price}&#160;
                    <RubleLightIcon size={9} color='currentColor'/>
                </li>}
            </ul>

            {!isMobile && <ul className='fabric-builder__footer-col role--info'>
                <li className='fabric-builder__footer-item'>
                    Состав: {composition}
                </li>
                <li className='fabric-builder__footer-item'>
                    <span>Плотность:</span> {density}
                </li>
            </ul>}
	    {someS && 
            <div className='fabric-builder__footer-wrapper2'>
	         <div class='fabric-builder__footer-col2 role--info'><br/>Для этой ткани применяется профессиональная варка, поэтому срок изготовления увеличиться на 3 недели, а размеры готовой рубашки могут отличаться на 1.5% от вашей стандартной.<br/><br/></div>
	    </div>
	    }

            <div className='fabric-builder__footer-wrapper'>
                <button href="#"
                    className="rit-button rit-button_theme_lightgray rit-button_size_medium"
                    onClick={onFabricInfoClicked}>
                    Детали
                </button>
            </div>
        </div>
    )
}
FabricFooter.propTypes = {
    displayName: PropTypes.string.isRequired,
    composition: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    density: PropTypes.number.isRequired,
    onFabricInfoClicked: PropTypes.func.isRequired,
    isMobile: PropTypes.bool.isRequired,
}
export default FabricFooter;
